var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"favourite-button",on:{"click":_vm.handleClick}},[_c('div',{staticClass:"favourite-button__star-wrapper"},[_c('bg-icon',{class:`favourite-button__star-wrapper__star-icon${
        _vm.buttonActive ? '--active' : ''
      }`,attrs:{"name":"star"}})],1),_c('div',{staticClass:"favourite-button__title"},[_vm._v("Favourite")])])
}
var staticRenderFns = []

export { render, staticRenderFns }